// extracted by mini-css-extract-plugin
export default {"skill-title":"Skills_skill-title__Hb2u0","items-container":"Skills_items-container__TzsZs","skill":"Skills_skill__LaR25"};